(() => {
  const dialog = document.getElementById('LegalGuaranteeDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const image = dialog.querySelector('[data-guarantee-image]');
  const status = dialog.querySelector('[data-guarantee-status]');
  let opener;

  image.addEventListener('load', () => {
    status.hidden = true;
    image.hidden = false;
  });

  image.addEventListener('error', () => {
    image.hidden = true;
    status.hidden = false;
    status.textContent = 'Das Bild konnte nicht geladen werden. Bitte nutzen Sie die Links zur EU-Seite oder zum Originalbild.';
    image.removeAttribute('src');
  });

  // Delegation keeps links working after Shopify replaces sections via AJAX.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-guarantee-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    opener = link;
    dialog.showModal();
    document.documentElement.classList.add('legal-guarantee-open');

    if (!image.hasAttribute('src')) {
      status.hidden = false;
      status.textContent = 'Das Label wird geladen …';
      image.src = image.dataset.src;
    }
  });

  dialog.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('legal-guarantee-open');
    if (opener && opener.isConnected) opener.focus();
  });
})();
